import { escape } from "lodash";
import { LetterText } from "lucide-react";

import { prop, define, useCraftProp } from "@/components/builder/utils";
import BubbleTiptap from '@/components/pure/Tiptap/bubble/Bubble';
import { useResponsive, useUtilities } from "@/modules/cms/views/post/components/builder/context";

import BasePreview from "./base";

function RichTextPreview({ ...props }) {
  const { value, setValue } = useCraftProp('content')
  const { device } = useResponsive()
  const { utilitiesParsed } = useUtilities()

  return <BasePreview {...props} key={`${device}.${utilitiesParsed}`}>
    <div>
      <BubbleTiptap
        content={value}
        onChange={setValue}
      />
    </div>
  </BasePreview>
}

function TextHTML({ content, attributes }) {
  return <div {...attributes} dangerouslySetInnerHTML={{ __html: escape(content) }} />
}

export default define('rich-text', RichTextPreview, TextHTML)
  .tag({ children: 'rich-text' })
  .property(prop.stylePattern())
  .property(prop.new('Content', 'content').hide().own())
  .palete(<LetterText size={16} />, 'Rich Text', 'Content')
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(prop.predefined.paragraphSpacing())
  .property(prop.predefined.textColor())
  .property(prop.predefined.align())
  .property(prop.predefined.letterSpacing())
  .property(prop.predefined.lineHeight())
  .property(prop.predefined.fontSize())
  .property(prop.predefined.fontWeight())
  .property(prop.predefined.fontFamily())
  .property(prop.predefined.fontDecoration())
  .property(prop.predefined.textShadow())
  .property(prop.predefined.attributes())
  .defaultProps({
    content: escape('Text here...'),
  })
  .build()
